import { render, staticRenderFns } from "./SubSchema.vue?vue&type=template&id=366944f4&"
import script from "./SubSchema.vue?vue&type=script&lang=js&"
export * from "./SubSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports